var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SampleForm',{attrs:{"sample":_vm.sample,"formType":_vm.formType,"buttonLoading":_vm.buttonLoading},on:{"saveSample":_vm.updateSample}})}
var staticRenderFns = []

export { render, staticRenderFns }